"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGeneratedLoanTapeToReceivableResponseTapeDependencies = exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape = exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes = void 0;
const common_1 = require("@finley-technologies/common");
const dbNodes = __importStar(require("../dbNodes/dbNodes"));
const utils = __importStar(require("../dbNodes/utils"));
const mesh = __importStar(require("./mesh"));
const createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes = ({ creditFacilitySlugs, dataTapes, cfToLpMap, }) => {
    const responseTapes = utils
        .filterReceivableResponseTapes({ dataTapes })
        .filter((tape) => !!tape.creditFacilitySlug &&
        creditFacilitySlugs.includes(tape.creditFacilitySlug));
    (0, common_1.finleyAssert)(responseTapes.length === creditFacilitySlugs.length, 'receivableResponseTapes must map 1:1 to creditFacilitySlugs');
    const responsesByFacility = new Map(responseTapes.map((tape) => [tape.creditFacilitySlug, tape]));
    const generatedLoanTapes = utils.filterGeneratedLoanTapes({ dataTapes });
    return creditFacilitySlugs.flatMap((cfSlug) => {
        const loanProducts = cfToLpMap[cfSlug];
        (0, common_1.finleyAssert)(loanProducts, `lpSlugs must be defined for creditFacilitySlug ${cfSlug}`);
        const response = responsesByFacility.get(cfSlug);
        (0, common_1.finleyAssert)(response, `receivable response tape must exist in cfSlugToReceivableResponseTapeMap for ${cfSlug}`);
        return generatedLoanTapes
            .filter((tape) => tape.loanProductSlug !== null &&
            loanProducts.includes(tape.loanProductSlug))
            .map((tape) => ({
            inputArtifactId: tape.id,
            outputArtifactId: response.id,
        }));
    });
};
exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes = createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes;
const createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape = ({ creditFacilitySlugs, dataTapes, }) => utils
    .filterMasterLoanTapes({ dataTapes })
    .filter((tape) => !!tape.creditFacilitySlug &&
    creditFacilitySlugs.includes(tape.creditFacilitySlug))
    .map((master) => {
    (0, common_1.finleyAssert)(dbNodes.masterLoanTape.isNode(master), `masterLoanTape ${master.artifactSlug} configuration is invalid`);
    const generated = utils.findArtifactBySlug({
        dataTapes,
        artifactSlug: master.configuration.generatedMasterLoanTapeArtifactSlug,
    });
    const { creditFacilitySlug } = generated;
    (0, common_1.finleyAssert)(creditFacilitySlug, `creditFacilitySlug must be defined for preassignedLoanTape generatedLoanTape ${generated.artifactSlug}`);
    const responses = utils
        .filterReceivableResponseTapes({ dataTapes })
        .filter((tape) => tape.creditFacilitySlug === creditFacilitySlug);
    (0, common_1.finleyAssert)(responses.length === 1, `receivableResponseTape must be unique per creditFacilitySlug ${creditFacilitySlug}`);
    return {
        inputArtifactId: generated.id,
        outputArtifactId: responses[0].id,
    };
});
exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape = createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape;
const createGeneratedLoanTapeToReceivableResponseTapeDependencies = ({ cfToLpMap, loanTapeTypeMap, dataTapes, }) => mesh
    .attachLoanTapeTypes({
    loanTapeTypeMap,
    lpCfSlugGroupings: mesh.createLpCfSlugGroupings(cfToLpMap),
})
    .flatMap(({ creditFacilitySlugs, loanTapeType }) => {
    switch (loanTapeType) {
        case 'masterLoanTape':
        case 'preassignedMasterLoanTape':
            return (0, exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes)({
                creditFacilitySlugs,
                dataTapes,
                cfToLpMap,
            });
        case 'preassignedLoanTape':
            return (0, exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape)({
                creditFacilitySlugs,
                dataTapes,
            });
        default:
            return (0, common_1.finleyAssertUnreachable)(loanTapeType);
    }
});
exports.createGeneratedLoanTapeToReceivableResponseTapeDependencies = createGeneratedLoanTapeToReceivableResponseTapeDependencies;
//# sourceMappingURL=loanTapeDependencies.js.map